export default __webpack_public_path__ + "static/media/desk-clean-img1.3704db3a.png";